import { useDispatch, useSelector } from 'react-redux';
import { setSelectedFilter } from 'config/appSlice';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import TouchstoneInput from 'components/common/TouchstoneInput';

function SelectFilter() {
    const dispatch = useDispatch();
    const selectedFilter = useSelector((state) => state.app.selectedFilter);

    const handleChange = (event) => {
        const formValue = event.target.value;
        dispatch(setSelectedFilter(formValue));
    };

    return (
        <FormControl>
            <InputLabel id='select-filter-label' shrink>
                Data Shown on Map
            </InputLabel>
            <Select
                labelId='select-filter-label'
                value={selectedFilter}
                onChange={handleChange}
                input={<TouchstoneInput />}
            >
                <MenuItem value={'normalized_status'}>Benchmarking Compliance Status</MenuItem>
                <MenuItem value={'normalized_net_site_eui'}>Site Energy Use Intensity</MenuItem>
                <MenuItem value={'energy_star_score'}>ENERGY STAR<sup>&reg;</sup> Score</MenuItem>
                <MenuItem value={'gross_floor_area'}>Property Size</MenuItem>
                <MenuItem value={'year_built'}>Year Built</MenuItem>
            </Select>
        </FormControl>
    );
}

export default SelectFilter;
